module.exports = "../study/imgs/maps/Nagano/S8/Climate/Temperture/Nagano_Temperture_MIROC5_RCP85_Mid.png";